import React, { useMemo } from "react"
import { Helmet } from "react-helmet-async"
import { useVenue } from "providers/venue"
import { get } from "lodash"
import { useTranslation } from "providers/i18n/useTranslation"

const isKioskV = process.env.REACT_APP_DEVICE === "kiosk-v"
const isKioskH = process.env.REACT_APP_DEVICE === "kiosk-h"
const isKiosk = isKioskV || isKioskH
const isNotProduction = process.env.REACT_APP_ENV !== "production"

export const Head = (props) => {
  const { title = "", description = "", suffixTitle } = props
  const { appManifest } = useVenue()
  const { t } = useTranslation()
  const defaultSuffixTitle = useMemo(
    () => ` - ${t(get(appManifest, "name", "Venue Indoor Map"))}`,
    [appManifest, t]
  )

  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{`${title}${suffixTitle || defaultSuffixTitle}`}</title>
      <meta name="description" content={description} />
      {/* End standard metadata tags */}

      {/* Disable Search on Kiosk or non-Production */}
      {(isKiosk || isNotProduction) && (
        <meta name="robots" content="noindex, nofollow" />
      )}
    </Helmet>
  )
}
